//import styles from './Layout.module.css';
import React from 'react'
import SkillsExpertise from '../SkillsExpertise/SkillsExpertise'
import SocialIcons from '../SocialIcons/SocialIcons'
import CertificationBadges from '../CertificationBadges/CertificationBadges'
import AnimatedGlitch from '../AnimatedGlitch/AnimatedGlitch'

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#03101f] relative overflow-y-visible" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>

      {/* Animated TV Static Glitch Effect on right edge */}
      <div className="absolute right-[-1.8rem] -top-[4.3225rem] z-10 pointer-events-none">
        <AnimatedGlitch
          width={225}
          height={200}
          cellSize={20}
          speed={460}
          speedVariance={0.7}
          density={0.35}
          persistence={0.65}
          primaryColor="#FA8906"
          secondaryColor="#03111F"
          tertiaryColor="#FA8906"
          quaternaryColor="#03111F"
        />
      </div>

      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-8 lg:px-8 lg:pt-16">
        <SkillsExpertise />

        <CertificationBadges className="mt-8" />

        <div className="mt-8 border-t border-white/10 pt-8 md:flex md:items-center md:justify-between">
          <SocialIcons className="md:order-2" />
          <p className="mt-8 text-xs leading-5 text-slate-500 md:order-1 md:mt-0">
            &copy; {year} Jasen Wyatt &bull; Valid Cat, LLC &bull; Hepkatt Detroit &bull; All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
